/* DSL Mobile sticky cart bar — verschijnt bij scroll-down op mobile */
(function(){
  if (window.matchMedia("(min-width: 750px)").matches) return;
  var bar = document.createElement("div");
  bar.className = "dsl-mobile-cart-bar";
  bar.innerHTML = "<a href=\"/cart\" data-cart-drawer-trigger aria-label=\"Open winkelwagen\"><span class=\"dsl-mobile-cart-bar__icon\">🛒</span> <span class=\"dsl-mobile-cart-bar__count\" data-cart-count>0</span></a>";
  bar.hidden = true;
  document.body.appendChild(bar);
  function refresh(){
    fetch("/cart.js").then(function(r){return r.json();}).then(function(c){
      var n = c.item_count;
      bar.querySelector("[data-cart-count]").textContent = n;
      bar.hidden = n === 0;
    }).catch(function(){});
  }
  document.addEventListener("DOMContentLoaded", refresh);
  document.addEventListener("dsl:cart:change", refresh);
})();